import { BaseFieldView } from '../BaseField/views';

export const RangeFieldView = BaseFieldView.extend({
    onRender: function () {
        var this_ = this;
        var DISABLED_VALUE = this.model.get('options')[0] - 1;
        var default_value = this.model.get('value') ? this.model.get('value') : DISABLED_VALUE;

        var _update = function (new_val, save) {
            if (typeof new_val !== 'undefined' && new_val !== null && new_val !== '') {
                new_val = parseInt(new_val);
            }

            if (new_val === DISABLED_VALUE) {
                new_val = ''; // field value is by default a string
            }

            this_.$el.find('.slider_value').html(new_val === '' ? '&mdash;' : new_val);

            if (!save) {
                return;
            }

            this_.save_value(new_val);
        };

        var el_slider = this.$el.find('.noUiSlider').get(0);
        noUiSlider.create(el_slider, {
            start: default_value,
            connect: [true, true], // fill the slider on the left side of the handle
            step: 1,
            range: {
                min: DISABLED_VALUE,
                max: this.model.get('options')[1]
            }
        });

        el_slider.noUiSlider.on('update', function (values, handle) {
            _update(values[handle], false);
        });

        el_slider.noUiSlider.on('change', function (values, handle) {
            _update(values[handle], true);
        });

        // Restore value if stored (for resuming app)
        _update(this.model.get('value'));
    },

    save_value: function (value) {
        if (value) {
            value = parseInt(value);
        }

        this.model.set({ value: value });
    }
});
